function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import isEmpty from 'lodash/isEmpty';
import valuesIn from 'lodash/valuesIn';
import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import find from 'lodash/find';
import { formatDateAsObject, formatObjectAsDate } from 'helpers/datetime';
import * as constants from '../../constants';
import stepsValidationRules from './stepsValidatorRules.json';
import alpineStepsValidationRules from './alpineStepsValidatorRules.json';
export const getStepValidationRules = (step, scope, isAlpineEnabled)=>{
    const validationRules = isAlpineEnabled === 'true' ? alpineStepsValidationRules : stepsValidationRules;
    const stepRules = validationRules[step];
    if (!stepRules) return undefined;
    const rulesForScope = stepRules[scope];
    if (rulesForScope && typeof rulesForScope === 'object' && !Array.isArray(rulesForScope)) {
        return rulesForScope;
    }
    return stepRules.default;
};
export const getFormValues = (identityRequirements, identityDefaults, invitation)=>{
    if (!isEmpty(identityRequirements)) {
        return _object_spread({}, identityDefaults, identityRequirements);
    }
    if (!isEmpty(invitation)) {
        const dateOfBirth = formatDateAsObject(invitation.information.dateOfBirth);
        const dateOfBirthAsDateFormat = formatObjectAsDate(dateOfBirth);
        return _object_spread_props(_object_spread({}, pick(invitation, [
            'scope',
            'countryCode'
        ]), pick(invitation.information, [
            'email',
            'firstName',
            'lastName'
        ])), {
            dateOfBirth,
            dateOfBirthAsDateFormat
        });
    }
    return {};
};
export const getBlsConstants = (blsKey)=>blsKey ? find(valuesIn(constants.APPS), (app)=>app.key === blsKey) : null;
export const pickLegalConsents = (object)=>pickBy(object, (value, key)=>key.startsWith('legalConsent-'));
export const getUrlWithLocale = (url, locale)=>{
    if (url.includes('.pdf')) {
        return url.replace('.pdf', `_${locale.toUpperCase()}.pdf`);
    }
    return url;
};
